import { ComponentProps } from "."
import { Icon, Input, Label, Polyline, StyledCheckbox, Wrapper } from "./styled"

const Checkbox = ({
  defaultIsChecked,
  inputId,
  internalIsChecked,
  isChecked,
  isControlled,
  label,
  labelId,
  name,
  onChange,
  ref,
  value
}: ComponentProps) => (
  <Wrapper>
    <Input
      defaultChecked={defaultIsChecked}
      id={inputId}
      name={name}
      onChange={onChange}
      ref={ref}
      value={value}
    />

    <StyledCheckbox
      $checked={isControlled ? isChecked : internalIsChecked}
      aria-checked={isChecked}
      aria-labelledby={labelId}
      htmlFor={inputId}
      role="checkbox"
    >
      <Icon viewBox="0 0 24 24">
        <Polyline points="20 6 9 17 4 12" />
      </Icon>
    </StyledCheckbox>

    <Label htmlFor={inputId} id={labelId}>
      {label}
    </Label>
  </Wrapper>
)

Checkbox.displayName = "Checkbox"

export default Checkbox
